
<img src="../../../assets/img/ori31 (26 of 32).jpg" style="z-index: -2;object-fit: cover;position: absolute;width: 100%;height: 100vh;">
<div class="heading" style=" text-align: center;line-height: 0.8;text-shadow: 2px 2px #0d4794; color: rgb(255, 255, 255);display: flex; justify-content: center;font-size: 4vw ;font-weight:500;margin-top: 5%; margin-bottom: 5%;">TUT Online Orientation</div>
<div *ngIf="step == 1" class="container page-container" style="background-color: white; width: 30rem;border-radius: 25px;margin-top: 2%;box-shadow: 10px 24px 70px -18px rgba(0, 0, 0, 0.32);">
    <div style="width:70%;margin-left: 15%;">

        <p style="padding-top: 15px; font-weight: bold; font-size: 17px;  text-align: center;"> Forgotten password. </p>
        <p style="padding-top: 5px; font-size: 13px;  text-align: center;"> Step 1/3 </p>
        <!-- <span *ngIf="error" (click)="removeError()">{{ error }}</span> -->
        <form>
            <div class="form-group">
                <label style="font-weight: bold" for="exampleInputEmail1">Email address</label>
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" name="email" [(ngModel)]="email" required>
            </div>
            <button type="submit" style="margin-left: 35%; margin-top: 7%;margin-bottom: 10%;" class="btn btn-primary" (click)="nextHandle()">Next</button>
        </form>
    </div>
</div>


<div *ngIf="step == 2" class="container page-container" style="background-color: white;width: 30rem;border-radius: 25px;margin-top: 2%;box-shadow: 10px 24px 70px -18px rgba(0, 0, 0, 0.32);">
    <div style="width:70%;margin-left: 15%;">

        <p style="padding-top: 15px; font-weight: bold; font-size: 17px;  text-align: center;"> Forgotten password. </p>
        <p style="padding-top: 5px; font-size: 13px;  text-align: center;"> Step 2/3 </p>
        <!-- <span *ngIf="error" (click)="removeError()">{{ error }}</span> -->
        <form>
            
            <p style="padding-top: 5px; font-size: 13px;  text-align: center;">Email was sent to {{ email }} if incorrect click 
            <a class="underlineHover" id="cursor" (click)="prevHandle()"><span class="text-danger">here</span></a></p>
            
            <div class="form-group">
                <label style="font-weight: bold" for="exampleInputEmail1">One Time Pin</label>
                <input type="text" class="form-control" id="otp" aria-describedby="emailHelp" placeholder="Enter OTP" name="otp" [(ngModel)]="otpField" required>
                <small id="emailHelp" class="form-text text-muted">Do not share the OTP with anyone else.</small>
            </div>

            <button type="submit" style="margin-left: 35%; margin-top: 7%;margin-bottom: 10%;" class="btn btn-primary" (click)="nextHandle()">Next</button>
        </form>

    </div>
</div>


<div *ngIf="step == 3"  class="container page-container" style="background-color: white;width: 30rem;border-radius: 25px;margin-top: 2%;box-shadow: 10px 24px 70px -18px rgba(0, 0, 0, 0.32);">
    <div style="width:70%;margin-left: 15%;">

        <p style="padding-top: 15px; font-weight: bold; font-size: 17px;  text-align: center;"> Forgotten password. </p>
        <p style="padding-top: 5px; font-size: 13px;  text-align: center;"> Step 3/3 </p>
        <!-- <span *ngIf="error" (click)="removeError()">{{ error }}</span> -->
        <form>
            

            <div class="form-group">
                <label style="font-weight: bold" for="exampleInputPassword1">Password</label>
                <input type="text" class="form-control"  id="exampleInputPassword1" placeholder="New Password" name="password" [(ngModel)]="password" required>
                <small style="color: red;"> Password must have atleast 6 characters = 1 special character, 1 UPPERCASE, 1 lowercase & 1 number</small>

            </div>


            <button type="submit" style="margin-left: 20%; margin-top: 7%; margin-bottom: 10%;" class="btn btn-primary" (click)="nextHandle()">Confirm new password</button>
        </form>

    </div>
</div>